import { MAX_MIGRATIONS_ATTEMPTS_PER_PAGE } from '../constants';
import { pageFailedMigrationCounter } from './pageMigrationCounter';

export const getIsReadonlyModePage = (pageId: string) =>
  pageFailedMigrationCounter.getMigrationCount(pageId) ===
  MAX_MIGRATIONS_ATTEMPTS_PER_PAGE;
